import { IntlShape } from 'react-intl'

import {
  ELIGIBILITY_TYPES,
  EligibilityInfo,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'
import { EligibilityField } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/types'
import { formatMessageHelper } from '@lyrahealth-inc/shared-app-logic/src/features/intl/utils/formatMessageHelper'
import { FormMetadata, RadioButtonType } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'

/**
 * DBT-specific eligibility metadata.
 * This replaces the standard "employee/dependent" question with a "self/teen" question.
 */
export const generateDbtEligibilityMetadata = (
  intl: IntlShape,
  eligibilityQuestionTitle: EligibilityInfo['eligibilityQuestionTitle'],
): FormMetadata => {
  return {
    schema: {
      type: 'object',
      properties: {
        [EligibilityField.ELIGIBILITY_TYPE]: {
          name: EligibilityField.ELIGIBILITY_TYPE,
          title: `#### ${formatMessageHelper(eligibilityQuestionTitle, false, intl.formatMessage)}`,
          type: 'string',
          enum: [ELIGIBILITY_TYPES.EMPLOYEE, ELIGIBILITY_TYPES.DEPENDENT],
          enumNames: [
            intl.formatMessage({
              defaultMessage: 'Yes',
              description: 'Button text for user confirming they are registering for themselves',
            }),
            intl.formatMessage({
              defaultMessage: 'No, I’m searching for a teen dependent',
              description: 'Button text for user indicating they are registering for a teen dependent',
            }),
          ],
          buttonType: RadioButtonType.DESCRIPTION_NO_OUTLINE,
          validation: {
            isRequired: true,
          },
        },
        dbtTeenErrorBanner: {
          type: 'string',
          name: 'dbtTeenErrorBanner',
          condition: {
            parentField: EligibilityField.ELIGIBILITY_TYPE,
            parentValue: ELIGIBILITY_TYPES.DEPENDENT,
          },
        },
      },
    },
    uiSchema: {
      'ui:order': ['dbtTeenErrorBanner', EligibilityField.ELIGIBILITY_TYPE],
      [EligibilityField.ELIGIBILITY_TYPE]: {
        'ui:widget': 'radio',
        'ui:options': {
          baseInputStyle: {
            marginBottom: 32,
            marginTop: 8,
          },
        },
      },
      dbtTeenErrorBanner: {
        'ui:field': 'DbtTeenErrorBanner',
      },
    },
  }
}
